import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropzone", "fileInput", "fileList", "placeholder"]

  dragover(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.add("border-[#6366F1]", "bg-[#EEF2FF]")
  }

  dragleave() {
    this.dropzoneTarget.classList.remove("border-[#6366F1]", "bg-[#EEF2FF]")
  }

  drop(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove("border-[#6366F1]", "bg-[#EEF2FF]")
    const files = event.dataTransfer.files
    this.fileInputTarget.files = files
    this._updateFileList(files)
  }

  clickZone() {
    this.fileInputTarget.click()
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  fileChanged(event) {
    this._updateFileList(event.target.files)
  }

  _updateFileList(files) {
    this.fileListTarget.innerHTML = ""
    Array.from(files).forEach((f) => {
      const d = document.createElement("div")
      d.className = "flex items-center gap-2 text-sm text-[#374151]"
      const sizeStr = f.size / 1024 < 1024
        ? (f.size / 1024).toFixed(0) + "KB"
        : (f.size / 1048576).toFixed(1) + "MB"
      d.innerHTML =
        "<svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='#6366F1' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z'/><path d='M14 2v4a2 2 0 0 0 2 2h4'/></svg>" +
        f.name +
        "<span class='text-xs text-[#9CA3AF]'>" + sizeStr + "</span>"
      this.fileListTarget.appendChild(d)
    })
    this.placeholderTarget.style.display = files.length ? "none" : "block"
  }
}
